import { render, staticRenderFns } from "./save.vue?vue&type=template&id=338f5fd0&scoped=true"
import script from "./save.vue?vue&type=script&lang=js"
export * from "./save.vue?vue&type=script&lang=js"
import style0 from "./save.vue?vue&type=style&index=0&id=338f5fd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338f5fd0",
  null
  
)

export default component.exports